import { Stack } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { ProgressBar } from 'settle-ui/components/ProgressBar/ProgressBar'
import { useOnboardingLayoutContext } from '../../hooks/useOnboardingLayoutContext/useOnboardingLayoutContext'
import { OnboardingStepper } from './components/OnboardingStepper/OnboardingStepper'
import {
  OnboardingProgressBar,
  type OnboardingProgressBarProps,
} from './components/OnboardingProgressBar/OnboardingProgressBar'
import { OnboardingBanners } from './components/OnboardingBanners/OnboardingBanners'

export interface OnboardingTopSectionProps extends Pick<OnboardingProgressBarProps, 'businessType'> {
  withProgressBar?: boolean
  progress?: number
  visibility: 'mobile' | 'desktop'
}

const progressBarSx: SxProps<Theme> = (theme) => ({
  width: '100%',
  [theme.breakpoints.down('mobile')]: {
    position: 'fixed',
    top: 0,
    left: 0,
    borderRadius: 0,
  },
  [theme.breakpoints.up('mobile')]: {
    maxWidth: 380,
    mx: 'auto',
    mb: 2,
  },
})

export const OnboardingTopSection: Settle.FC<OnboardingTopSectionProps> = ({
  businessType,
  withProgressBar,
  visibility,
  progress,
  ...props
}) => {
  const { flowType } = useOnboardingLayoutContext()

  return (
    <Stack
      sx={{
        ...(visibility === 'mobile'
          ? { display: { xs: 'flex', mobile: 'none' }, width: '100%' }
          : { display: { xs: 'none', mobile: 'flex' }, width: '100%', maxWidth: 800 }),
      }}
      {...props}
    >
      {withProgressBar &&
        (progress !== undefined ? (
          <ProgressBar variant="determinate" value={progress} sx={progressBarSx} />
        ) : (
          <OnboardingProgressBar businessType={businessType} sx={progressBarSx} />
        ))}
      {flowType && <OnboardingStepper />}
      <OnboardingBanners />
    </Stack>
  )
}
